import Toolbar from "@mui/material/Toolbar";
import Head from "next/head";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import FreeLandingPage from "../../components/employer/FreeLandingPage/FreeLandingPage";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import EmployerNavbar from "../../components/shared/SharedNavbar/Navbar/EmployerNavbar";

function Benefits() {
  const posthog = usePostHog();

  const posthogHideELPPostForFree =
    posthog.getFeatureFlag("elp-hide-post-for-free") == "hide-navbar";
  const isELPPostion = posthogHideELPPostForFree ? "hidden" : "shown";

  useEffect(() => {
    localStorage.setItem("posthogPosition", "bottom_promo");
    localStorage.setItem("posthogImage", isELPPostion);
    localStorage.setItem("posthogRegisterELP", "false");
  }, []);

  useEffect(() => {
    const params = new URL(window.location.href).searchParams;
    const utms = {};
    for (const [key, value] of params.entries()) {
      utms[key] = value;
    }
    if (Object.keys(utms).length) {
      localStorage.setItem("utm_params", JSON.stringify(utms));
    }
  }, []);

  let metaTitle = "Retail F&B Hospitality | Hiredly Malaysia";
  let metaDescription =
    "Check out our recruitment products and pricing options. Flexible, affordable, and designed to help employers hire effectively.";

  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />
        <link
          rel="canonical"
          href="https://my.hiredly.com/employer/retail-fnb-hospitality"
        />
      </Head>

      <ToResolveClassNameError>
        <EmployerNavbar />
        <Toolbar />
        <FreeLandingPage />
      </ToResolveClassNameError>
    </>
  );
}

export default Benefits;
